<template>
  <button
    class="btn btn-primary button-with-loading"
    :class="{'btn-success': this.state == 'success', 'btn-danger': this.state == 'failure'}"
    :disabled="state === 'loading' || state === 'success'"
  >
    <slot></slot>
    {{message}}
    <span
      v-if="state == 'loading'"
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"
    ></span>
    <IconBase v-if="state === 'success'" icon-name="check" height="20px" width="20px">
      <IconCheck/>
    </IconBase>
  </button>
</template>

<script>
import IconBase from "@/components/iconbase";
import IconCheck from "@/components/icons/IconCheck.vue";

export default {
  name: "ButtonWithLoading",
  components: {
    IconBase,
    IconCheck
  },
  props: [
    "text", //default text
    "loadingText", //text to show while loading
    "successText", //text to show on success
    "failureText", //text to show on failure
    "state", //current state of the button [null (default), loading, success, failure]
    "click" //click handler
  ],
  computed: {
    message() {
      if (!this.state) {
        return this.text;
      } else if (this.state === "loading") {
        return this.loadingText;
      } else if (this.state === "success") {
        return this.successText;
      } else if (this.state === "failure") {
        return this.failureText;
      }
      return this.text;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
